import { Text } from "@ds/react";
import styled from "styled-components/macro";

export const InputWrapper = styled.div(({ half }) => ({
  minWidth: half && "50%",
  display: "flex",
  flexDirection: "column",
}));

export const TextFieldLabel = styled(Text)(({ theme }) => ({
  fontWeight: "normal",
  marginBottom: theme.spacing.stack["5xs"],
  whiteSpace: "normal",

  "&.label-error": {
    color: theme.color.feedback.error,
  },

  [theme.breakpoint.md()]: {
    whiteSpace: "nowrap",
  },
}));

export const TextFieldHelperText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing.stack["5xs"],
  color: theme.color.neutral["03"],
}));

export const SuccessText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing.stack["5xs"],
  color: theme.color.feedback.success,
  svg: {
    fill: theme.color.feedback.success,
    marginRight: "8px",
  },
}));

export const ErrorText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing.stack["5xs"],
  color: theme.color.feedback.error,
  fontWeight: 500,
}));

export const CurrencyInput = styled.input({});
